'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateFileAttachmentsWithThread = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _fileIdsAreResolved = require('../../resolved-attachments/selectors/fileIdsAreResolved');

var _associateFileIdsWithThread = require('./associateFileIdsWithThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var associateFileAttachmentsWithThread = exports.associateFileAttachmentsWithThread = function associateFileAttachmentsWithThread(_ref) {
  var attachments = _ref.attachments,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });

    if (!attachments || !attachments.size) {
      return _q2.default.Promise.resolve();
    }

    var fileAttachment = attachments.first();
    var fileIds = (0, _get2.default)('fileIds', fileAttachment);

    if ((0, _fileIdsAreResolved.fileIdsAreResolved)(getState(), { thread: thread, fileIds: fileIds })) {
      return _q2.default.Promise.resolve();
    }

    return dispatch((0, _associateFileIdsWithThread.associateFileIdsWithThread)({
      fileIds: fileIds,
      sessionId: sessionId,
      threadId: threadId
    }));
  };
};